import { IWhitelabelConfig } from '../components/organisms/user/creator-details.typings';

export type LabelKey = keyof IWhitelabelConfig;

export const getLabel = (
  config: IWhitelabelConfig | null | undefined,
  key: LabelKey,
  fallback: string,
): string => {
  const value = config?.[key];
  if (typeof value === 'string' && value.trim().length > 0) return value.trim();
  return fallback;
};

export const getTermByCount = (
  config: IWhitelabelConfig | null | undefined,
  singularKey: LabelKey,
  pluralKey: LabelKey,
  count: number,
  fallbackSingular: string,
  fallbackPlural: string,
): string => {
  return count === 1
    ? getLabel(config, singularKey, fallbackSingular)
    : getLabel(config, pluralKey, fallbackPlural);
};
